import { AxiosResponse } from "axios";
import TagManager from "react-gtm-module";
import _ from "lodash";

import { tApplication, tBrandAdminOptions } from "tmt_api/src/types/types.validator";

import api from "src/util/api";
import { getLegacyApiError } from "src/util/apiNew";
import { getSafeUrl } from "src/util/functions";
import { formatPhoneNumber } from "src/util/gFormatting";
import { makeDRAFT } from "src/util/types";
import * as asyncStorage from "src/util/asyncStorage";
import { kRoute } from "src/kRoute";

import * as kNav from "../../RootNavigation";

import { handleErrorEvents } from "../errorHandler/actions";
import { tReduxAction } from "../types";
import { tApplicationState, tApplicationState_DRAFT } from "./types";

export const acceptApplication =
  (id: string, myApplicationData: tApplicationState, adminOption: tBrandAdminOptions): tReduxAction =>
  (dispatch) => {
    const regexp = /^\((\d{3})\) ?(\d{3})-(\d{4})$/;
    const matches = formatPhoneNumber(myApplicationData.contact.phone).match(regexp);

    if (matches?.length !== 4) {
      dispatch({
        type: "RIBBON",
        message: new Error("Invalid phone number"),
      });
      return;
    }

    const aUpdatedData: tApplication = makeDRAFT(_.cloneDeep(myApplicationData));
    aUpdatedData.contact.phone = `+1${matches[1]}${matches[2]}${matches[3]}`;
    aUpdatedData.website = getSafeUrl(aUpdatedData.website);
    aUpdatedData.socialMedia = _.mapValues(aUpdatedData.socialMedia, (socialMedia) => getSafeUrl(socialMedia));

    let aApplicationPut: Promise<AxiosResponse>;

    if (aUpdatedData.type === "brand") {
      aApplicationPut = api.put({
        endpoint: `/applications/${id}/accept` as const,
        body: { type: "BRAND", application: aUpdatedData, brandAdminOptions: adminOption },
      });
    } else if (aUpdatedData.type === "rep") {
      aApplicationPut = api.put({
        endpoint: `/applications/${id}/accept` as const,
        body: { type: "REP", application: aUpdatedData },
      });
    } else {
      aApplicationPut = api.put({
        endpoint: `/applications/${id}/accept` as const,
        body: { type: "RETAIL", application: aUpdatedData },
      });
    }
    aApplicationPut
      .then(() => {
        dispatch(handleErrorEvents("The application has been accepted", "success"));
        dispatch({
          type: "SET_LOADING_CONNECTIONS",
          loading: false,
        });
      })
      .catch((error) => {
        dispatch(handleErrorEvents(error.message, "error", error));
        dispatch({
          type: "SET_LOADING_CONNECTIONS",
          loading: false,
        });
      });
  };

type tpDeclineApplication = (id: string) => tReduxAction;
export const declineApplication: tpDeclineApplication = (id) => (dispatch) => {
  api
    .put({ endpoint: `/applications/${id}/decline` as const })
    .then(() => {
      dispatch(handleErrorEvents("The application has been declined", "success"));
      dispatch({
        type: "SET_LOADING_CONNECTIONS",
        loading: false,
      });
    })
    .catch((error) => {
      dispatch(handleErrorEvents(error.message, "error", error));
      dispatch({
        type: "SET_LOADING_CONNECTIONS",
        loading: false,
      });
    });

  dispatch({
    type: "SET_LOADING_CONNECTIONS",
    loading: true,
  });
};

export const pushApplicationData = (myApplication: tApplicationState): tReduxAction => {
  return async (dispatch) => {
    // TODO: Add loading state.
    const regexp = /^\((\d{3})\) ?(\d{3})-(\d{4})$/;
    const matches = myApplication.contact.phone.match(regexp);

    if (matches?.length !== 4) {
      dispatch({
        type: "RIBBON",
        message: new Error("Invalid phone number"),
      });
      return;
    }

    const tempApplication: tApplicationState_DRAFT = makeDRAFT(_.cloneDeep(myApplication));
    tempApplication.contact.phone = `+1${matches[1]}${matches[2]}${matches[3]}`;
    tempApplication.website = getSafeUrl(tempApplication.website);
    tempApplication.socialMedia = _.mapValues(tempApplication.socialMedia, getSafeUrl);

    try {
      const maybeReferralId = await asyncStorage.getData("referralId");
      if (maybeReferralId && (tempApplication.type === "brand" || tempApplication.type === "rep")) {
        tempApplication.referralId = maybeReferralId;
      }
      await api.postNoAuth({ endpoint: "/applications", body: tempApplication });
      await asyncStorage.removeData("referralId");

      dispatch({ type: "APPLICATION_RESET" });

      if (window.fbq) {
        TagManager.dataLayer({ dataLayer: { joinAs: tempApplication.type, event: "applicationSubmit" } });
      }
      kNav.navigate(kRoute.P01_02);
    } catch (error) {
      dispatch({ type: "RIBBON", message: new Error(getLegacyApiError(error).message) });
      throw error;
    }
  };
};
